import React from "react";

import styles from "./HotelListview.module.css";

const HotelList = ({ hotels = [] }) => {

  return (
    <div className={styles.hotelList}>

      {hotels.map((hotel) => {

        const hotelImage =
          hotel.featured_image ||
          hotel.image ||
          hotel.images?.[0]?.image ||
          null;

        return (
          <article
            key={
              hotel.id ||
              hotel.slug ||
              hotel.name
            }
            className={styles.hotelItem}
          >

            {/* ==========================================
                HOTEL IMAGE
            ========================================== */}

            <div
              className={
                styles.imageWrapper
              }
            >

              {hotelImage ? (

                <img
                  src={hotelImage}
                  alt={
                    hotel.name ||
                    "Hotel"
                  }
                  className={
                    styles.hotelImage
                  }
                  loading="lazy"
                />

              ) : (

                <div
                  className={
                    styles.imagePlaceholder
                  }
                >
                  Hotel
                </div>

              )}

            </div>


            {/* ==========================================
                HOTEL INFORMATION
            ========================================== */}

            <div
              className={
                styles.hotelInfo
              }
            >

              <h3
                className={
                  styles.hotelName
                }
              >
                {hotel.name}
              </h3>


              {/* LOCATION */}

              {(hotel.city ||
                hotel.state) && (

                <p
                  className={
                    styles.location
                  }
                >
                  {[
                    hotel.city,
                    hotel.state,
                  ]
                    .filter(Boolean)
                    .join(", ")}
                </p>

              )}


              {/* STAR RATING */}

              {hotel.star_rating && (

                <div
                  className={
                    styles.rating
                  }
                >
                  ★ {hotel.star_rating}
                </div>

              )}


              {/* DESCRIPTION */}

              {hotel.description && (

                <p
                  className={
                    styles.description
                  }
                >
                  {hotel.description}
                </p>

              )}

            </div>


            {/* ==========================================
                ACTION
            ========================================== */}

            <div
              className={
                styles.actionWrapper
              }
            >

              <button
                type="button"
                className={
                  styles.viewButton
                }
              >
                View Hotel
              </button>

            </div>

          </article>
        );

      })}

    </div>
  );
};

export default HotelList;